import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getAdminsState = (state: GlobalState) => state[KEY];

const selectAdmins = createSelector(getAdminsState, (admins) => admins.admins);

const selectPinCode = createSelector(getAdminsState, (admins) => admins.pinCode);

const selectAdmin = createSelector(getAdminsState, (admins) => admins.admin);

const selectAction = createSelector(getAdminsState, (admins) => admins.action);

export const selectors = {
  selectAdmin,
  selectPinCode,
  selectAdmins,
  selectAction
};
